export const ANALYTICS_CONSENT_COOKIE = 'cookieConsentAnalytics';

export function areAnalyticsCookiesAllowed(cookieSource?: string): boolean {
  if (typeof cookieSource === 'string') {
    return cookieSource
      .split(';')
      .some((cookie) => cookie.trim() === `${ANALYTICS_CONSENT_COOKIE}=true`);
  }

  if (typeof document === 'undefined') {
    return false;
  }

  return areAnalyticsCookiesAllowed(document.cookie);
}
